import { Suspense } from 'react';

import { useSuspenseQuery } from '@tanstack/react-query';

import { Chip, Skeleton } from '@mui/material';

import { useFieldContext } from '#form';

import { claimQueries } from '@repo/api/claim/claims';
import { CodeInput } from '@repo/ui/CodeInput';
import { LabelInput } from '@repo/ui/LabelInput';

export function CATCodeInput() {
	const field = useFieldContext<number | null | undefined>();

	return (
		<Suspense
			fallback={
				<LabelInput label="CAT Code" fieldName={field.name}>
					<Skeleton />
				</LabelInput>
			}
		>
			<CATCodeField />
		</Suspense>
	);
}

function CATCodeField() {
	const field = useFieldContext<number | null | undefined>();

	const { data: catCodes } = useSuspenseQuery(claimQueries.catCodes());

	return (
		<CodeInput
			label="CAT Code"
			name={field.name}
			value={field.state.value}
			onChange={field.handleChange}
			errors={field.state.meta.errors}
			codes={[
				{
					category: '',
					items: catCodes,
				},
			]}
			minInput={0}
			renderCode={(code) => (
				<Chip size="small" label={<code>{code}</code>} sx={{ minWidth: 48 }} />
			)}
		/>
	);
}
